import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

// Components
import { InputField, SupportingMessage } from "@octopus-investments/deep-sea-components";

// Styles
import "./PasswordField.scss";

export default function PasswordField({ className, errorMsg, showError, value, ...rest }) {
  const passwordFieldClasses = classNames(
    "input-field",
    "password-field",
    showError && "has-error",
    className,
  );

  return (
    <div className={passwordFieldClasses}>
      <InputField
        name="password"
        autoComplete="off"
        value={value || ""}
        iconPosition="right"
        placeholder="Enter your password"
        required
        type="password"
        id="passwordField"
        {...rest}
      />
      {showError && <SupportingMessage status="error" message={errorMsg} />}
    </div>
  );
}

PasswordField.propTypes = {
  className: PropTypes.string,
  errorMsg: PropTypes.string,
  showError: PropTypes.bool,
  value: PropTypes.string,
};
